"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";

export default function ForgotUsernameForm() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setMessage("");

    try {
      const response = await fetch("/api/customer/forgot-username", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const result = await response.json();
      setMessage(result.message || "If an eligible account exists and delivery succeeds, username instructions will arrive shortly.");
    } catch {
      setMessage("If an eligible account exists and delivery succeeds, username instructions will arrive shortly.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form
      action="/api/customer/forgot-username"
      method="post"
      onSubmit={handleSubmit}
      className="rounded-md border border-[var(--vintera-border)] bg-white p-6"
    >
      <h2 className="text-2xl font-bold text-[var(--vintera-navy)]">
        Forgot username
      </h2>
      <p className="mt-2 leading-7 text-[var(--vintera-muted)]">
        Enter the portal login email associated with your account.
      </p>

      <label className="mt-6 block">
        <span className="text-sm font-semibold text-[var(--vintera-navy)]">
          Portal login email
        </span>
        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          type="email"
          autoComplete="email"
          required
          className="mt-2 w-full rounded-md border border-[var(--vintera-border)] px-4 py-3 text-[var(--vintera-ink)] outline-none transition focus:border-[var(--vintera-navy)]"
        />
      </label>

      {message && (
        <p className="mt-5 rounded-md bg-[var(--vintera-sage-soft)] p-4 text-sm font-medium text-[var(--vintera-navy)]">
          {message}
        </p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="mt-6 w-full rounded-md bg-[var(--vintera-navy)] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[var(--vintera-navy-hover)] disabled:cursor-not-allowed disabled:opacity-60"
      >
        {submitting ? "Sending..." : "Send Username"}
      </button>

      <Link
        href="/login"
        className="mt-5 inline-flex text-sm font-semibold text-[var(--vintera-navy)] hover:underline"
      >
        Back to Login
      </Link>
    </form>
  );
}
